"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            details: null,
            showPosterPlus: false,
            showPosterPlusLoading: false,
            editMode: false,
            suggestions: []
        };
    },
    onMount: function () {
        this.getDepartment();
    },
    onEdit: function (status) {
        this.state.editMode = status || false;
    },
    onSearchResult: function (results) {
        this.state.suggestions = results.map(({profile, account}) => {
            return {
                poster: {
                    type: 'image',
                    value: profile.photo
                },
                title: profile.first_name + ' ' + profile.last_name,
                subtitle: profile.email
            };
        });
    },
    onSearchDismiss: function () {
        this.state.suggestions = [];
    },
    onSelectSuggestion: function (index) {
        this.sendUpdate('manager', this.state.suggestions[index].subtitle);
        this.onSearchDismiss();
    },
    selectPoster: function (status) {
        this.state.showPosterPlus = status || false;
    },
    setPoster: async function ({base64, src}) {
        if (!src)
            return;
        this.state.showPosterPlus = false;
        this.state.showPosterPlusLoading = true;
        try {
            const {error, message, department} = await Request('/department/update/' + this.input.params.id, 'PUT', { poster: base64 || src });
            this.state.showPosterPlusLoading = false;
            if (error)
                return console.log('Error Updating Department Poster: ', message);
            this.state.details = department;
        } catch (error) {
            this.state.showPosterPlusLoading = false;
            console.log('Error Updating Department Poster: ', error);
        }
    },
    sendUpdate: async function (name, e) {
        const value = typeof e == 'string' ? e : e.target.value;
        if (!value)
            return;
        try {
            const {error, message, department} = await Request('/department/update/' + this.input.params.id, 'PUT', { [name]: value });
            if (error)
                return console.log('Error Updating Department: ', message);
            this.state.details = department;
        } catch (error) {
            console.log('Error Updating Department: ', error);
        }
    },
    getDepartment: async function () {
        try {
            const {error, message, department} = await Request('/department/' + this.input.params.id);
            if (error)
                console.log('Error Fetching Department: ', message);
            this.state.details = department || false;
        } catch (error) {
            console.log('Error Fetching Department', error);
            this.state.details = false;
        }
    },
    deleteDepartment: async function () {
        try {
            const {error, message} = await Request('/department/delete/' + this.input.params.id, 'DELETE');
            if (error)
                return console.log('Error: ', message);
            navigate('/departments');
        } catch (error) {
            console.log('Error Deleting Shop: ', error);
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Departments/View.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    LoadingPage_template = require("../../components/LoadingPage.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    LoadingPage_tag = marko_loadTag(LoadingPage_template),
    EmptyList_template = require("../../components/EmptyList.marko"),
    EmptyList_tag = marko_loadTag(EmptyList_template),
    Image_template = require("../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    PosterPlus_template = require("../../../components/PosterPlus/index.marko"),
    PosterPlus_tag = marko_loadTag(PosterPlus_template),
    Preloader_template = require("../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    SearchBar_template = require("../../../components/SearchBar/index.marko"),
    SearchBar_tag = marko_loadTag(SearchBar_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    WSAdapt_template = require("../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Wrapper_Admin_template = require("../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "position-relative"
      },
    marko_attrs1 = {
        "class": "position-absolute btn theme-bg shadow btn-icon glow",
        style: "left:10px;bottom:10px;"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("6604f2"),
    marko_node0 = marko_createElement("br", null, "11", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "12", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("i", {
        "class": "bx bx-camera font-medium-5"
      }, "10", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "form-group"
      },
    marko_attrs3 = {
        "class": "form-group"
      },
    marko_attrs4 = {
        "class": "form-group"
      },
    marko_node3 = marko_createElement("br", null, "20", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs5 = {
        "class": "btn btn-primary btn-lg"
      },
    marko_attrs6 = {
        "class": "font-medium-3"
      },
    marko_node4 = marko_createElement("br", null, "24", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs7 = {
        "class": "list-unstyled"
      },
    marko_attrs8 = {
        "class": "py-75 font-medium-1"
      },
    marko_node5 = marko_createElement("br", null, "31", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node6 = marko_createElement("br", null, "32", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs9 = {
        "class": "btn btn-light btn-lg m-25"
      },
    marko_attrs10 = {
        "class": "btn btn-primary btn-lg m-25"
      },
    marko_node7 = marko_createElement("i", {
        "class": "bx bx-minus font-medium-2 text-muted mr-4 float-left"
      }, "28", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node8 = marko_createElement("strong", null, "29", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Manager: ");

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      title: state.details && state.details.name,
      renderBody: function(out, { page, themeMode }) {
        if (state.details === null) {
          LoadingPage_tag({}, out, __component, "1");
        } else if (state.details === false) {
          EmptyList_tag({
              message: "The page you are trying to access is nowhere to be found",
              routeTo: "departments"
            }, out, __component, "2");
        } else {
          Row_tag({
              class: "m-0",
              renderBody: function(out) {
                WSAdapt_tag({
                    class: "col-3",
                    renderBody: function(out) {
                      out.be("div", marko_attrs0, "5", component);

                      Image_tag({
                          alt: state.details.name,
                          src: state.details.poster,
                          class: "img-fluid rounded",
                          style: "width:100%;min-height:12rem"
                        }, out, __component, "6");

                      if (state.showPosterPlus == true) {
                        PosterPlus_tag({
                            cdn: "department",
                            width: 280,
                            height: 280,
                            maxSize: 1024,
                            theme: themeMode
                          }, out, __component, "7", [
                          [
                            "done",
                            "setPoster",
                            false
                          ],
                          [
                            "cancelled",
                            "selectPoster",
                            false,
                            [
                                false
                              ]
                          ]
                        ]);
                      }

                      out.be("button", marko_attrs1, "8", component, null, 0, {
                          onclick: __component.d("click", "selectPoster", false, [
                              true
                            ])
                        });

                      Preloader_tag({
                          active: state.showPosterPlusLoading
                        }, out, __component, "9");

                      if (!state.showPosterPlusLoading) {
                        out.n(marko_node2, component);
                      }

                      out.ee();

                      out.ee();

                      out.n(marko_node0, component);

                      out.n(marko_node1, component);

                      if (state.editMode) {
                        out.be("div", null, "13", component);

                        out.e("div", marko_attrs2, "14", component, 1)
                          .e("input", {
                              type: "text",
                              value: state.details.name,
                              "class": "form-control form-control-lg pl-4",
                              placeholder: Locale("Name of the department")
                            }, "15", component, 0, 0, {
                              onchange: __component.d("change", "sendUpdate", false, [
                                  "name"
                                ])
                            });

                        out.e("div", marko_attrs3, "16", component, 1)
                          .e("textarea", {
                              type: "text",
                              value: state.details.description,
                              name: "description",
                              "class": "form-control form-control-lg pl-4",
                              placeholder: Locale("Description"),
                              style: marko_styleValue({
                                  height: "100px",
                                  resize: "none"
                                })
                            }, "17", component, 0, 0, {
                              onchange: __component.d("change", "sendUpdate", false, [
                                  "description"
                                ])
                            });

                        out.be("div", marko_attrs4, "18", component);

                        SearchBar_tag({
                            size: "xl",
                            icon: "bx-user",
                            target: "user",
                            minLength: 3,
                            suggestions: state.suggestions,
                            placeholder: Locale("Add a manager")
                          }, out, __component, "19", [
                          [
                            "blur",
                            "onSearchDismiss",
                            false
                          ],
                          [
                            "result",
                            "onSearchResult",
                            false
                          ],
                          [
                            "select",
                            "onSelectSuggestion",
                            false
                          ]
                        ]);

                        out.ee();

                        out.n(marko_node3, component);

                        out.be("button", marko_attrs5, "21", component, null, 0, {
                            onclick: __component.d("click", "onEdit", false, [
                                false
                              ])
                          });

                        Locale_tag({
                            text: "Done"
                          }, out, __component, "22");

                        out.ee();

                        out.ee();
                      } else {
                        out.e("p", marko_attrs6, "23", component, 1)
                          .t(state.details.description, component);

                        out.n(marko_node4, component);

                        out.be("ul", marko_attrs7, "25", component);

                        out.be("li", marko_attrs8, "26", component);

                        route_link_tag({
                            href: "/user/" + state.details.manager,
                            class: "justify-content-center",
                            renderBody: function(out) {
                              out.n(marko_node7, component);

                              out.n(marko_node8, component);

                              out.e("span", null, "30", component, 1)
                                .t(state.details.manager, component);
                            }
                          }, out, __component, "27");

                        out.ee();

                        out.ee();

                        out.n(marko_node5, component);

                        out.n(marko_node6, component);

                        out.be("button", marko_attrs9, "33", component, null, 0, {
                            onclick: __component.d("click", "deleteDepartment", false)
                          });

                        Locale_tag({
                            text: "Delete"
                          }, out, __component, "34");

                        out.ee();

                        out.be("button", marko_attrs10, "35", component, null, 0, {
                            onclick: __component.d("click", "onEdit", false, [
                                true
                              ])
                          });

                        Locale_tag({
                            text: "Edit"
                          }, out, __component, "36");

                        out.ee();
                      }
                    }
                  }, out, __component, "4");

                WSAdapt_tag({
                    class: "col"
                  }, out, __component, "37");
              }
            }, out, __component, "3");
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
